import Swiper, { Navigation, Pagination, Autoplay, Parallax } from 'swiper';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import 'swiper/scss/autoplay';
import 'swiper/scss/effect-fade';
if (customElements.get('component-carousel') === undefined) {
    class Carousel extends HTMLElement {
        constructor() {
            super();
            this.images = this.querySelectorAll('img');
            this.swiper = this.querySelector('.swiper');
            this.carousel = null;
            this.current = this.querySelector('.swiper-current');
        }
        static get observedAttributes() {
            return [];
        }
        attributeChangedCallback(attr, oldVal, newVal) {
            if (oldVal !== newVal) {
                this[attr] = newVal;
            }
        }
        connectedCallback() {
            this.setCarousel();
        }
        setCarousel() {
            this.carousel = new Swiper(this.swiper, {
                modules: [Navigation, Pagination, Autoplay, Parallax],
                speed: 700,
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'progressbar',
                    clickable: true,
                },
                on: {
                    init: () => {
                        this.images.forEach((image) => {
                            image.classList.add('loaded');
                        });
                    },
                    slideChange: () => {
                        this.current.innerText = this.carousel.activeIndex < 9 ? '0' + (this.carousel.activeIndex + 1).toString() : (this.carousel.activeIndex + 1).toString();
                    }
                },
                longSwipesRatio: 0.01,
                followFinger: false,
                watchSlidesProgress: true,
                parallax: true,
                lazy: {
                    loadPrevNext: true,
                }
            });
        }
    }
    customElements.define('component-carousel', Carousel);
}
